const ModifyJSONFieldsStyles = () => ({
  textField: {
    marginBottom: '20px',
  },
});

export default ModifyJSONFieldsStyles;
